import React from 'react'

import NewProject from './NewProject'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const NewProjectPage = () => (
  <section>
    <header>
      <PageTitle>New Project</PageTitle>
    </header>
    <NewProject />
    <br/>
    <BackButton/>
  </section>
)

export default NewProjectPage



// WEBPACK FOOTER //
// ./src/components/Projects/NewProjectPage.jsx